<script>
import { getAccountLogo, updateFaviconAndTitle } from "../../utils/helpers";
import modalUploadImage from "../modals/modal-upload-image";
import smtpNoReplyEmail from "./setting-smtp-no-reply-email";

export default {
  name: "accountInformation",
  data() {
    return {
      user: _.get(this, '$A.Auth', {}),
      oldNoReplyEmail: _.get(this, '$A.Auth.account.noReplyEmail', ""),
      newNoReplyEmail: _.get(this, '$A.Auth.account.noReplyEmail', ""),
      oldWhiteLabelDomainName: _.get(this, '$A.Auth.account.whiteLabelDomainName', ""),
      newWhiteLabelDomainName: _.get(this, '$A.Auth.account.whiteLabelDomainName', ""),
      validated: false,
    };
  },
  components: {
    modalUploadImage,
    smtpNoReplyEmail,
  },
  computed: {
    curAccount: function() {
      return _.get(this, 'user.account', {});
    },
    curLogo: function () {
      return this.$A.CurLogo();
    },
    isDisabled: function () {
      return !_.get(this, 'curAccount.subscriptionState.whiteLabelEnabled', false);
    },
    isPersonalStarterOrStandardSku: function () {
      const curSku = _.get(this, 'curAccount.subscriptionState.sku');
      const allowedSku = ['personal-4', 'freelancer-3', 'standard-1', 'standard-1-annual'];
      return allowedSku.includes(curSku);
    },
    hasCustomLogo: function () {
      const uri = _.get(this, 'curAccount.whiteLabelLogoUri', '') || '';
      return uri !== '' && uri.indexOf('logo-large') === -1;
    }
  },
  methods: {
    showUploadImageModal: function () {
      this.$refs.uploadImageModal.openModal();
    },
    updateAccountInfo: async function () {
      let account = await this.$A.AccountService.UpdateAccount(
          this.curAccount.name,
          null,
          this.curAccount.timeZone,
          this.curAccount.dateFormat,
          this.newWhiteLabelDomainName,
          null
      );

      if (account) {
        this.updateFaviconAndTitle({accountTitle: this.curAccount.name})
        this.$A.Auth.account = account;
        this.$A.SaveSessionData(this.$A.Auth);
      }

      if (this.newWhiteLabelDomainName !== this.oldWhiteLabelDomainName) {
        this.oldWhiteLabelDomainName = this.newWhiteLabelDomainName;
        this.$A.AlertUser(
            "Please Allow 24 hours before using this new domain. The SSL cert will be provisioned as soon as possible.",
            "success",
            30000
        );
      }
    },
    get(object, path, defaultValue) {
      return _.get(object, path, defaultValue);
    },
    updateFaviconAndTitle
  },
  mounted() {
    let self = this;
    this.$root.$on("account::logo::updated", function (image) {
      _.set(self, 'user.account.whiteLabelLogoUri', image);

      self.$emit("uploadAccountLogo", image);
    });
  },
};
</script>

<template>
  <div class="org-stack">
    <!-- Organization Settings -->
    <div class="settings-card">
      <div class="card-head">
        <div class="card-head-title">Organization Settings</div>
        <div class="card-head-subtitle">Your company name, review domain, and date format.</div>
      </div>
      <div class="card-body">
        <div class="field">
          <label class="field-label" for="companyName">Company Name</label>
          <input data-cy="companyNameInput"
                 id="companyName"
                 type="text"
                 class="text-input"
                 placeholder="Company Name"
                 v-model="curAccount.name"
          />
        </div>
        <div class="field"
             @click="!get(curAccount, 'subscriptionState.domainWhiteLabelEnabled', false) ? $A.BuyNow(): null">
          <label class="field-label">Domain</label>
          <p class="field-help">
            Whitelabel your proof review links.
            Point the CNAME Record of your subdomain to "http://ingress.ashoreapp.com"
            and update the field below with your new domain.
            Within 24 hours, an SSL certificate will be installed for your new domain.
          </p>
          <input
              type="text"
              :class="'text-input ' + ((isDisabled || isPersonalStarterOrStandardSku) ? 'disabled-input': '')"
              v-model="newWhiteLabelDomainName"
              :disabled="isDisabled || isPersonalStarterOrStandardSku"
          />
        </div>
        <div class="field">
          <label class="field-label">Date Format</label>
          <div class="select-wrap">
            <select class="select-input" v-if="get($A, 'Auth.account', {})" v-model="$A.Auth.account.dateFormat">
              <option value="MM-DD-YYYY">MM-DD-YYYY</option>
              <option value="DD-MM-YYYY">DD-MM-YYYY</option>
              <option value="YYYY-MM-DD">YYYY-MM-DD</option>
            </select>
            <svg class="select-caret" width="10" height="6" viewBox="0 0 10 6" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="1 1 5 5 9 1" />
            </svg>
          </div>
        </div>
      </div>
      <div class="card-foot">
        <a
            data-cy="updateAccountInfoBtn"
            class="primary-btn"
            @click="updateAccountInfo">Save</a>
      </div>
    </div>

    <!-- Account Logo -->
    <div class="settings-card">
      <div class="card-head">
        <div class="card-head-title">Account Logo</div>
        <div class="card-head-subtitle">Your logo replaces the Ashore logo across the app and review screens.</div>
      </div>
      <div class="card-body logo-body">
        <button
            v-if="hasCustomLogo"
            type="button"
            class="logo-tile"
            :class="{ 'is-locked': !get($A, 'Auth.account.subscriptionState.whiteLabelEnabled', false) }"
            title="Change account logo"
            @click="get($A, 'Auth.account.subscriptionState.whiteLabelEnabled', false) ? showUploadImageModal() : $A.BuyNow()"
        >
          <span class="logo-image" :style="{ backgroundImage: 'url(' + curLogo + ')' }"></span>
          <span class="logo-overlay" v-if="get($A, 'Auth.account.subscriptionState.whiteLabelEnabled', false)">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
              <circle cx="12" cy="13" r="4" />
            </svg>
            Change
          </span>
        </button>
        <button
            v-else
            type="button"
            class="logo-tile logo-empty"
            title="Add your logo"
            @click="get($A, 'Auth.account.subscriptionState.whiteLabelEnabled', false) ? showUploadImageModal() : $A.BuyNow()"
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
            <circle cx="8.5" cy="8.5" r="1.5" />
            <polyline points="21 15 16 10 5 21" />
          </svg>
          <span class="logo-empty-title">Add your logo</span>
          <span class="logo-empty-text">PNG, JPG, or GIF — it'll appear in the nav and on review screens.</span>
        </button>
      </div>
      <div class="card-foot">
        <b-button v-show="!get($A, 'Auth.account.subscriptionState.whiteLabelEnabled', false)"
                  class="locked-btn"
                  @click="$A.BuyNow()"
                  v-b-tooltip.hover="'Upgrade to rebrand Ashore'">
          Feature Locked <img src="/img/feature-lock.svg" class="feature-icon ml-2"/>
        </b-button>
        <a
            v-show="get($A, 'Auth.account.subscriptionState.whiteLabelEnabled', false)"
            class="primary-btn"
            @click="showUploadImageModal">Upload Logo</a>
      </div>
    </div>

    <!-- Email Settings Account -->
    <smtp-no-reply-email :is-account-settings="true" :noReplyEmail="newNoReplyEmail"/>

    <modalUploadImage type="logo" ref="uploadImageModal"/>
  </div>
</template>

<style scoped>
.org-stack {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.settings-card {
  background: #fff;
  border: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(8, 11, 13, 0.04), 0 8px 24px -16px rgba(8, 11, 13, 0.1);
}
.card-head {
  padding: 14px 20px;
  background: #fbfbfc;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 12px 12px 0 0;
}
.card-head-title {
  font-size: 15px;
  font-weight: 600;
  color: #111827;
}
.card-head-subtitle {
  margin-top: 1px;
  font-size: 12.5px;
  font-weight: 400;
  color: #6b7280;
}
.card-body {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
}
.card-foot {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 20px;
  background: #fbfbfc;
  border-top: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 0 0 12px 12px;
}
.field-label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  color: #6b7280;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  margin-bottom: 6px;
}
.field-help {
  margin: 0 0 8px;
  font-size: 12.5px;
  font-weight: 400;
  color: #6b7280;
  line-height: 1.55;
}
.text-input {
  width: 100%;
  height: 38px;
  padding: 0 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 13px;
  color: #1f2937;
  background: #fff;
  outline: none;
  box-shadow: 0 1px 2px rgba(8, 11, 13, 0.05);
  transition: border-color 120ms ease, box-shadow 120ms ease;
}
.text-input:focus {
  border-color: #019256;
  box-shadow: 0 0 0 3px rgba(1, 146, 86, 0.12);
}
.disabled-input {
  background-color: #f3f4f6 !important;
  opacity: 1 !important;
  cursor: not-allowed;
}
.select-wrap {
  position: relative;
  max-width: 280px;
}
.select-input {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 100%;
  height: 38px;
  padding: 0 32px 0 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 13px;
  color: #1f2937;
  background: #fff;
  outline: none;
  cursor: pointer;
  transition: border-color 120ms ease, box-shadow 120ms ease;
}
.select-input:focus {
  border-color: #019256;
  box-shadow: 0 0 0 3px rgba(1, 146, 86, 0.12);
}
.select-caret {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #6b7280;
  pointer-events: none;
}

/* Logo */
.logo-body {
  align-items: flex-start;
}
.logo-tile {
  position: relative;
  width: 220px;
  height: 160px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 10px;
  background: #fff;
  padding: 12px;
  cursor: pointer;
  overflow: hidden;
}
.logo-tile.is-locked {
  cursor: pointer;
}
.logo-image {
  display: block;
  width: 100%;
  height: 100%;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}
.logo-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  background: rgba(17, 24, 39, 0.45);
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  opacity: 0;
  transition: opacity 120ms ease;
}
.logo-tile:hover .logo-overlay {
  opacity: 1;
}
.logo-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 1.5px dashed #c2c8d0;
  background: rgba(1, 146, 86, 0.04);
  color: #6b7280;
  transition: border-color 120ms ease, background-color 120ms ease;
}
.logo-empty:hover {
  border-color: #019256;
  background: rgba(1, 146, 86, 0.08);
}
.logo-empty svg {
  color: #9ca3af;
}
.logo-empty-title {
  font-size: 13px;
  font-weight: 600;
  color: #111827;
}
.logo-empty-text {
  font-size: 11.5px;
  font-weight: 500;
  color: #6b7280;
  max-width: 180px;
  line-height: 1.45;
}

/* Buttons */
.primary-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 18px;
  background: #019256;
  color: #fff;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  transition: background-color 120ms ease;
}
.primary-btn:hover {
  background: #017a48;
  color: #fff;
  text-decoration: none;
}
.locked-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 16px;
  background: #F44271;
  border: 0;
  color: #fff;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(8, 11, 13, 0.05);
}
.locked-btn:hover,
.locked-btn:focus,
.locked-btn:active {
  background: #F44271 !important;
  opacity: 0.9;
  color: #fff;
}
.feature-icon {
  height: 14px;
}

@media (max-width: 575px) {
  .logo-tile {
    width: 100%;
  }
  .primary-btn,
  .locked-btn {
    flex: 1;
  }
}
</style>
